import { Dimensions, TextMeasures } from '@inter-ikea-storageone/range';
import { IStorageOneDexfSettings, IStorageOneTranslations } from 'contexts/serviceSettings';
import { adjustMeasurementsSystem } from 'utils/adjustMeasurementsSystem';
import { TransformProduct } from './fetchProducts';

export interface Measures {
  dimensions: Dimensions;
  communicatedDimensions: Dimensions;
  communicatedDimensionsLocalized: TextMeasures;
}

/**
 * Transforms measures for different product types to Dimensions
 * suitable for filtering
 */

export const transformMeasures = (
  product: TransformProduct,
  dexfSettings: IStorageOneDexfSettings,
  translations: IStorageOneTranslations
): Measures => {
  const dimensions: Dimensions = transformDimensions(product.size);
  const communicatedDimensions: Dimensions = transformDimensions(product.comSize);
  const communicatedDimensionsLocalized: TextMeasures = {
    width: adjustMeasurementsSystem(
      product.comSize.width,
      translations,
      dexfSettings.localisation.useMetricMeasures
    ),
    height: adjustMeasurementsSystem(
      product.comSize.height,
      translations,
      dexfSettings.localisation.useMetricMeasures
    ),
    depth: adjustMeasurementsSystem(
      product.comSize.depth,
      translations,
      dexfSettings.localisation.useMetricMeasures
    ),
    unit: dexfSettings.localisation.useMetricMeasures
      ? translations.kompis.measureValueCm
      : translations.kompis.measureValueIn
  };

  return {
    dimensions,
    communicatedDimensions,
    communicatedDimensionsLocalized
  };
};

export const transformDimensions = (dimensions: any): Dimensions => {
  return {
    width: dimensions?.width,
    height: dimensions?.height,
    depth: dimensions?.depth
  };
};
